import styled from 'theme';

export const LinkElement = styled.a<{ to?: string }>`
  text-decoration: none;
`;
